import { makeStyles } from "@mui/styles";
export default makeStyles((theme) => ({
  profile: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // width: '400px',
  },
  logout: {
    whiteSpace: 'nowrap',
  }
}));